<template>
    <div class="wrapper">
      <div class="speaker">
        <img :src="value.tIcon" alt="" v-if="value.tIcon">
        <div>
          <p><span style="color: #333333;font-size: 0.32rem;">{{value.tName?value.tName:''}}</span><span style="color: #666666;font-size: 0.24rem;margin-left: 0.2rem;">{{value.tPost}}</span></p>
          <p style="color: #333333;font-size: 0.24rem;">{{value.tOrg}} </p>
        </div>
      </div>
      <div class="instro">
        <span id="desc">{{value.tInstro}}</span>
      </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
              word:''
            }
        },
        props: {
          value:{
            type:Object,
            default:()=> {
              return {tName:"", tOrg:"", tInstro:'',}

            }

          }
        },
        methods: {},
        computed: {},
        mounted() {
        }
    }
</script>
<style scoped lang="scss">
  .wrapper{
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
  }
  div{
    background: #FFFFFF;
  }
  .speaker{
    display: flex;
    /*height: 90px;*/
    /*margin-top: 24px;*/
    img{
      width: 40px;
      height: 40px;
      margin-top: 10px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      margin-right: 10px;
    }
    div{
      color: #333333;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p{
        font-size: 20px;
      }
    }
  }
  .instro{
    font-size: 0.28rem;
    color: #333333;
    margin-top: 0.43rem;
    span{
      display: inline-block;
      text-indent: 0.56rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/container/lecturer.vue